import React from "react";
import { StyledTopPart } from "../Catalog/styled";
import { Grid, SvgIcon, Typography } from "@mui/material";
import { colors } from "../../theme/colors";
import OkyCouple from "../../assets/como funciona oky.webp";
import { StyledSubtitle, StyledTopWrapprer } from "./styled";
import GridImage from "../../assets/elige como funciona oky ebi.webp";
import EbiPayTicket from "../../assets/paga como funciona oky ebi.webp";
import EcosistemasBiTicket from "../../assets/newLine/pay-bi.webp";
import CheckEbi from "../../assets/enviamos como funciona oky ebi.webp";
import EbiCouple from "../../assets/OkyCouple.png";
import { ReactComponent as NotificationIcon } from "../../assets/svg/notification-active.svg";
import { ReactComponent as TicketIcon } from "../../assets/svg/ticket2-default.svg";
import { ReactComponent as HeartIcon } from "../../assets/svg/Trazado 19268.svg";
import { ReactComponent as StoreIcon } from "../../assets/svg/store-default.svg";
import { ReactComponent as BagError } from "../../assets/svg/shopping-decline.svg";
import { ReactComponent as Coin } from "../../assets/svg/quetzal-default.svg";
import { ReactComponent as TicketIconSecondary } from "../../assets/svg/ticket-1.svg";

export default function HowItWorks() {
  return (
    <>
      <StyledTopPart height="180px" />

      <Typography
        variant="h2"
        sx={{
          color: colors.white.main,
          position: "absolute",
          top: "calc(25px - 25px + 200px)",
          left: "calc(50vw)",
          transform: "translateX(-50%)",
          textAlign: "center",
        }}
      >
        ¿Cómo funciona?
      </Typography>

      <StyledTopWrapprer>
        <Grid
          container
          columnGap={1}
          justifyContent="center"
          alignItems="center"
          sx={{
            position: "absolute",
            width: { xs: "100%" },
            margin: { xs: "auto", md: "auto" },
            bottom: { sm: "-20px", xs: "0px" },
            left: { sm: "50%" },
            transform: { sm: "translateX(-50%)" },
            height: { xs: "100%", md: "auto" },
            overflow: "hidden",
          }}
        >
          <Grid
            item
            lg={4}
            md={5}
            sm={6}
            xs={12}
            sx={{
              display: { xs: "none", md: "block" },
            }}
          >
            <img
              src={OkyCouple}
              alt="check"
              style={{ maxHeight: "100%", maxWidth: "100%" }}
              height="450px"
            />
          </Grid>
          <Grid
            item
            lg={4}
            md={5}
            sm={6}
            sx={{
              textAlign: { xs: "center" },
              paddingLeft: { xs: "0 !important" },
              paddingTop: { xs: "4rem !important" },
            }}
          >
            <Typography
              variant="h3"
              sx={{ marginBottom: "1rem", fontSize: { xs: "2rem" } }}
            >
              Vales prepagados fácil y rápido
            </Typography>
            <span
              style={{
                fontSize: "18px",
                color: colors.primary,
                fontFamily: "OpenSans",
              }}
            >
              Puedes elegir la marca y producto de lo que deseas enviar a tus
              seres queridos
            </span>
          </Grid>
          <Grid
            item
            lg={5}
            md={5}
            sm={6}
            xs={12}
            sx={{
              display: { md: "none" },
              position: { xs: "relative" },
              bottom: { xs: "-34px" },
              textAlign: "center",
            }}
          >
            <img
              src={OkyCouple}
              alt="check"
              style={{ maxHeight: "100%", maxWidth: "100%" }}
            />
          </Grid>
        </Grid>
      </StyledTopWrapprer>

      <div style={{ maxWidth: "95vw", margin: "auto" }}>
        <Typography
          variant="h3"
          sx={{
            marginTop: { md: "350px", xs: "650px" },
            textAlign: "center",
          }}
        >
          Pasos
        </Typography>
        <div
          style={{
            textAlign: "center",
          }}
        >
          <StyledSubtitle>¡Elige, compra y envía felicidad!</StyledSubtitle>
        </div>

        <Grid
          container
          spacing={2}
          justifyContent="center"
          textAlign="center"
          sx={{ width: "85%", margin: "auto" }}
        >
          <Grid item sm={12} md={12} lg={4}>
            <img
              src={GridImage}
              style={{ height: "234px", maxWidth: "90%" }}
              alt="grid"
            />
            <Typography variant="h4">Elige</Typography>
            <Typography variant="h5">
              lo que deseas enviarle a tu ser querido de marcas reconocidas.
            </Typography>
          </Grid>
          <Grid item sm={12} md={12} lg={4}>
            <img
              src={EcosistemasBiTicket}
              style={{ height: "234px", maxWidth: "90%" }}
              alt="ticket"
            />
            <Typography variant="h4">Paga</Typography>
            <Typography variant="h5">
              con tarjeta de crédito o débito a través de Ecosistema Bi.
            </Typography>
          </Grid>
          <Grid item sm={12} md={12} lg={4}>
            <img
              src={CheckEbi}
              style={{ height: "234px", maxWidth: "90%" }}
              alt="check"
            />
            <Typography variant="h4">Enviamos</Typography>
            <Typography variant="h5">
              el vale a tus seres queridos por ti, por mensaje de texto o correo
              electrónico.
            </Typography>
          </Grid>
        </Grid>

        <div
          style={{
            backgroundColor: colors.gray.light,
            paddingTop: "4rem",
            paddingBottom: "4rem",
            marginTop: "5rem",
          }}
        >
          <Typography
            variant="h3"
            sx={{ textAlign: "center", fontSize: { xs: "2rem" } }}
          >
            Canje de vales
          </Typography>

          <div
            style={{
              textAlign: "center",
            }}
          >
            <StyledSubtitle>Pasos para el beneficiario</StyledSubtitle>

            <Grid container spacing={2} sx={{ width: "85%", margin: "auto" }}>
              <Grid
                item
                display="flex"
                alignItems="center"
                gap={2}
                md={4}
                sm={12}
                textAlign="start"
              >
                <SvgIcon
                  component={NotificationIcon}
                  inheritViewBox
                  sx={{ fontSize: "40px" }}
                />
                <Typography variant="h5">
                  Reciben un código de canje.
                </Typography>
              </Grid>
              <Grid
                item
                display="flex"
                alignItems="center"
                gap={2}
                md={4}
                sm={12}
                textAlign="start"
              >
                <SvgIcon
                  component={TicketIcon}
                  inheritViewBox
                  sx={{ fontSize: "40px" }}
                />
                <Typography variant="h5">
                  Presentan el código del vale OKY en la sucursal más cercana.
                </Typography>
              </Grid>
              <Grid
                item
                display="flex"
                alignItems="center"
                gap={2}
                md={4}
                sm={12}
                textAlign="start"
              >
                <SvgIcon
                  component={HeartIcon}
                  inheritViewBox
                  sx={{ fontSize: "40px" }}
                />
                <Typography variant="h5">
                  Le entregarán el producto para que lo disfrute.
                </Typography>
              </Grid>
            </Grid>
          </div>
        </div>

        <Grid
          container
          spacing={2}
          justifyContent="center"
          textAlign="center"
          sx={{
            width: "85%",
            margin: "auto",
            marginTop: "100px",
            marginBottom: "150px",
          }}
        >
          <Grid item md={6} sx={{ display: { xs: "none", md: "block" } }}>
            <img src={EbiCouple} alt="Exchange" style={{ maxWidth: "90%" }} />
          </Grid>

          <Grid item md={6} sm={10}>
            <Typography
              variant="h3"
              sx={{
                fontSize: { xs: "2rem" },
                textAlign: { xs: "start", sm: "center" },
                marginBottom: { xs: "1rem" },
              }}
            >
              Uso y canje del vale
            </Typography>
            <Grid container direction="column">
              <Grid
                item
                display="flex"
                alignItems="center"
                gap={5}
                sm={4}
                textAlign="start"
              >
                <SvgIcon
                  component={StoreIcon}
                  inheritViewBox
                  sx={{ fontSize: "40px" }}
                />
                <Typography variant="h6">
                  <strong>Canje Únicamente por Productos o Servicios: </strong>
                  Bajo ninguna circunstancia podrá un vale ser canjeado por
                  dinero en efectivo. El vale no es una tarjeta de crédito ni de
                  débito.
                </Typography>
              </Grid>
              <Grid
                item
                display="flex"
                alignItems="center"
                gap={5}
                sm={4}
                textAlign="start"
              >
                <SvgIcon
                  component={BagError}
                  inheritViewBox
                  sx={{ fontSize: "40px" }}
                />
                <Typography variant="h6">
                  <strong>Cambios de Mercadería: </strong>Una vez canjeado el
                  vale en el establecimiento comercial, cualquier cambio de
                  productos o servicios adquiridos queda sujeto a las políticas
                  de cambios aplicables del establecimiento comercial.
                </Typography>
              </Grid>
              <Grid
                item
                display="flex"
                alignItems="center"
                gap={5}
                sm={4}
                textAlign="start"
              >
                <SvgIcon
                  component={Coin}
                  inheritViewBox
                  sx={{ fontSize: "40px" }}
                />
                <Typography variant="h6">
                  <strong>Transferencia de Vales: </strong>Se recomienda que no
                  se comparta o transfiera el código del vale con otra persona.
                  El código del vale es un crédito aplicable al portador y,
                  siempre y cuando el código no haya expirado, será canjeado por
                  el establecimiento comercial al momento de ser presentado para
                  su canje por el portador.
                </Typography>
              </Grid>
              <Grid
                item
                display="flex"
                alignItems="center"
                gap={5}
                sm={4}
                textAlign="start"
              >
                <SvgIcon
                  component={TicketIconSecondary}
                  inheritViewBox
                  sx={{ fontSize: "40px" }}
                />
                <Typography variant="h6">
                  <strong>Comercialización de Vales: </strong>El receptor del
                  vale no debe vender o comercializar el vale o el código.
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
}
